import React from 'react'
import { useIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from '../Inbox.css';
// Locale
import messages from '../../../locale/jsonMessages';
import NoDataView from '../../NoDataView/NoDataView';
//Image
import noDataIcon from '/public/SiteIcons/noMessageIcon.svg';
const EmptyInbox = ({ type }) => {

  const { formatMessage } = useIntl();

  return (
    <div className={(s.textCenter)}>
      <NoDataView
        noDataIcon={noDataIcon}
        title={formatMessage(messages.noMessagesTitle)}
        content1={formatMessage(type == "owner" ? messages.noMessagesTitle3 : messages.noMessagesTitle2)}
      />
    </div>
  );
}

export default withStyles(s)(EmptyInbox);
